import { TEALIUM_INTERACTION_ID } from '@client/analytics/types/types';
import { ANALYTICS_ATTRIBUTES, BaseBuilder } from '@client/analytics/utils/builders/BaseBuilder';

// DSA component tracking event IDs (see _docs/DSA component tracking spec).
const CONTEXT_LINK_INTERACTION_ID = '965';

export class ContextLinkAnalyticsBuilder extends BaseBuilder<any> {
  protected attributes = [
    ANALYTICS_ATTRIBUTES.category,
    ANALYTICS_ATTRIBUTES.subcategory,
    ANALYTICS_ATTRIBUTES.attribute1,
    ANALYTICS_ATTRIBUTES.attribute2,
    ANALYTICS_ATTRIBUTES.location,
    ANALYTICS_ATTRIBUTES.innerlocation,
  ];

  public constructor(
    private readonly linkText: string,
    private readonly section: string,
    private readonly element: string,
  ) {
    super();
  }

  public build(): any {
    this.analyticsResultObject = {
      [ANALYTICS_ATTRIBUTES.category]: ['account'],
      [ANALYTICS_ATTRIBUTES.subcategory]: ['context_link'],
      [ANALYTICS_ATTRIBUTES.attribute1]: [this.linkText],
      [ANALYTICS_ATTRIBUTES.attribute2]: ['go-to'],
      [ANALYTICS_ATTRIBUTES.location]: [this.section],
      [ANALYTICS_ATTRIBUTES.innerlocation]: [this.element],
    };

    return {
      interaction: TEALIUM_INTERACTION_ID.genericEvent,
      interaction_id: CONTEXT_LINK_INTERACTION_ID,
      [ANALYTICS_ATTRIBUTES.component]: {
        ...super.build(),
      },
    };
  }
}
